export default __webpack_public_path__ + "a609dc0f334a7d4e64205247c4e8b97c.ttf";